import Stack from '@mui/material/Stack';
import { SwiperSlide } from 'swiper/react';
import { RelatedContentItem } from '../../../api/types/research-related-content-response';
import { MobileResearchArticlesTile, ResearchArticlesTile } from './ResearchArticlesTile';
import Divider from '@mui/material/Divider';
import ResearchArticlesPrompt, { IResearchPrompt } from './ResearchArticlesPrompt';

const MOBILE_SLIDE_WIDTH = 256;
const MOBILE_SLIDE_HEIGHT = 250;
const ARTICLES_PER_SLIDE = 3;

const chunkResearchItems = (researchRelatedContentItems: RelatedContentItem[]) => {
    const chunks: RelatedContentItem[][] = [];
    for (let i = 0; i < researchRelatedContentItems.length; i += ARTICLES_PER_SLIDE) {
        chunks.push(researchRelatedContentItems.slice(i, i + ARTICLES_PER_SLIDE));
    }
    return chunks;
};

interface IUFTResearchArticlesSlidesProps {
    isMobile: boolean;
    researchRelatedContentItems: RelatedContentItem[];
}

export const UFTResearchArticlesSlides = ({
    isMobile,
    researchRelatedContentItems,
}: IUFTResearchArticlesSlidesProps) => {
    if (!isMobile) {
        return researchRelatedContentItems.map((tileData: RelatedContentItem, index: number) => (
            <SwiperSlide key={tileData.title}>
                <ResearchArticlesTile content={tileData} itemIndex={index} />
            </SwiperSlide>
        ));
    }

    const mobileSlides = chunkResearchItems(researchRelatedContentItems);
    return mobileSlides.map((chunk, slideIndex) => (
        <SwiperSlide key={`mobile-slide-${slideIndex}`}>
            <Stack spacing={2} sx={{ width: MOBILE_SLIDE_WIDTH }} divider={<Divider />}>
                {chunk.map((tileData, tileIndex) => (
                    <MobileResearchArticlesTile
                        key={tileData.title}
                        content={tileData}
                        itemIndex={slideIndex * ARTICLES_PER_SLIDE + tileIndex}
                    />
                ))}
            </Stack>
        </SwiperSlide>
    ));
};

interface IResearchArticlesSlidesProps {
    researchRelatedContentItems: RelatedContentItem[];
    researchPromptData: IResearchPrompt;
}

export const ResearchArticlesSlides = ({
    researchRelatedContentItems,
    researchPromptData,
}: IResearchArticlesSlidesProps) => [
    ...researchRelatedContentItems.map((tileData: RelatedContentItem, index: number) => (
        <SwiperSlide key={tileData.title}>
            <ResearchArticlesTile content={tileData} itemIndex={index} />
        </SwiperSlide>
    )),
    <SwiperSlide key="research-prompt">
        <ResearchArticlesPrompt content={researchPromptData} itemIndex={researchRelatedContentItems.length} />
    </SwiperSlide>,
];
